var jvzooTrackingGaEvents = (function () {

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function jvzooTrackingGaEvents(category) {
        this.category = category;
        this.userError = category + ' User Error';
        this.userSuccess = category + ' User Success'
        this.invalidDeliveryEmail = category + ' User Entered Invalid Delivery Email';
        this.invalidPayPalEmail = category + ' User Entered Invalid Delivery Email';
        this.validDeliveryEmail = category + ' User enters valid delivery email';
        this.validPayPalEmail = category + ' User enters valid delivery paypal email';
        this.checkOutWithPayPal = category + ' User checkout with PayPal';
    }


    function sendDataToGA(category, eventAction, eventLabel) {
        console.log('send data to google analytics');
        ga('send', {
            hitType: 'event',
            eventCategory: category,
            eventAction: eventAction,
            eventLabel: eventLabel
        });
    }

    jvzooTrackingGaEvents.prototype.loaded = function () {
        /*
        *
        */
        var formErrorClass = 'formerror';
        var pageErrors = document.getElementsByClassName(formErrorClass);
        if (pageErrors.length > 0) {
            for (var item in pageErrors) {
                if (!isNaN(item)) {
                    var errorLabel = pageErrors[item].innerText;
                    sendDataToGA(this.category, this.userError, errorLabel);
                }
            }
        }

    }

    jvzooTrackingGaEvents.prototype.validateEmailOtherPayments = function (checkoutType) {
        /*
        *
        *
        *
        */
        var contact_email = $('[name="contact_email"]');
        var paypal_email = $('[name="paypal_email"]');
        var paypal_cc_checkoutIsChecked = $('[name="paypal_cc_checkout"]').is(":checked");

        if (contact_email.length > 0) {
            if (validateEmail(contact_email.val())) {

                sendDataToGA(this.category, this.userSuccess, this.validDeliveryEmail)
                sendDataToGA(this.category, this.userSuccess, this.category + ' User checkout with ' + checkoutType)

            }
            else {
                sendDataToGA(this.category, this.userError, this.invalidDeliveryEmail)
            }
        }
    }


    jvzooTrackingGaEvents.prototype.validateEmail = function () {
        var contact_email = $('[name="contact_email"]');
        var paypal_email = $('[name="paypal_email"]');
        var paypal_cc_checkoutIsChecked = $('[name="paypal_cc_checkout"]').is(":checked");

        console.log($('[name="paypal_cc_checkout"]'));
        console.log(paypal_cc_checkoutIsChecked);
        console.log(paypal_cc_checkoutIsChecked == true);

        if (contact_email.length > 0) {
            if (validateEmail(contact_email.val())) {
                console.log(this.userSuccess);
                sendDataToGA(this.category, this.userSuccess, this.validDeliveryEmail)
            }
            else {
                sendDataToGA(this.category, this.userError, this.invalidDeliveryEmail)
            }
        }

        if (paypal_email.length > 0 && paypal_cc_checkoutIsChecked == true) {
            console.log('validate the paypal email address');
            if (validateEmail(paypal_email.val())) {

                sendDataToGA(this.category, this.userSuccess, this.validPayPalEmail);

                sendDataToGA(this.category, this.userSuccess, this.category + ' User checkout with PayPal');

            }
            else {
                sendDataToGA(this.category, this.userError, this.invalidPayPalEmail);
            }
        }

    }

    jvzooTrackingGaEvents.prototype.checkoutWithPayPal = function () {
        //paypal_checkout
        var _this = this;
        $('[name="paypal_checkout"]').click(function (e) {
            //e.preventDefault();
            _this.validateEmail();
        });
    }

    jvzooTrackingGaEvents.prototype.checkoutWithCreditCardOtherThanPayPal = function () {
        //paypal_checkout
        //change this function to work with the other credit card options via value='merchant' and pass over the name attribute value to GA
        var _this = this;

        $('input[value="merchant"]').click(function (e) {
            //e.preventDefault();
            var nameAttr = $(this).attr('name');
            console.log(nameAttr);
            _this.validateEmailOtherPayments(nameAttr);
            //send data to ga.
        });
    }

    jvzooTrackingGaEvents.prototype.trackItemsOnClick = function () {
        this.checkoutWithPayPal();
        this.checkoutWithCreditCardOtherThanPayPal();
    }


    return jvzooTrackingGaEvents;

})();


/*
$(document).ready(function () {
    var jvzTrackGa = new jvzooTrackingGaEvents('Checkout Page');
    console.log(jvzTrackGa);
    jvzTrackGa.loaded();
    jvzTrackGa.trackItemsOnClick();
});
*/




